import { render } from "./subheader-report.vue?vue&type=template&id=3a0b66fb"
import script from "./subheader-report.vue?vue&type=script&lang=js"
export * from "./subheader-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__